import React, { useContext, useEffect, useRef, useState } from 'react'
import MenuHeader from './../MenuHeader'
import { Form, FormGroup, Input } from 'reactstrap'
import { ProductContext } from '../../../../store';
import DetailSkeleton from '../../../Skeleton/DetailSkeleton';
import Select from 'react-select'

const GeneralSearch = ({type, pageLoader}) => {
	const divRef = useRef(null),
		[height, setHeight] = useState("100vh"),
		[channelSelect, setChannelSelect]	= useState(false),
		{
			setSearchPhrase,
			searchPhrase,
			description,
			setDescription,
			exact,
			setExact,
			editSearchPhraseMerchandising,
			loadVisualEditor,
			setEnableSave,
			setProducts,
			setOriginalProducts,
			setBuried,
			setPinnedItems,
			setHiddenProductIndex,
			setPinnedProductIndex,
			setHidden,
			setPromoted,
			setBuriedProducts,
			setHiddenProducts,
			setChannelId,
			channelId,
			buried,
			merchandisingError,
			channels,
			setSelectedPromoTiles,
			channelLoader
		}	= useContext(ProductContext)
	
	useEffect(() => {
		const calculateHeight = () => {
			if (divRef.current) {
			  const topPosition = divRef.current.getBoundingClientRect().top
			  const newHeight = `calc(100vh - ${topPosition}px)`
			  setHeight(newHeight)
			}
		 }
		 // Calculate height initially
		 calculateHeight()
	
		 // Recalculate height on window resize
		 window.addEventListener("resize", calculateHeight)
		 return () => {
			window.removeEventListener("resize", calculateHeight)
		 }
	}, [divRef, loadVisualEditor])

	useEffect(() => {
		if( type === "new" && Object.keys(channels).length > 0 ){
			setChannelId(Object.keys(channels)[0])
		}
	}, [channels, type])

	const updateChannelId = (channelIdLocal) => {
		setEnableSave(false)
		setProducts([])
		setBuried([])
		setHidden([])
		setPromoted([])
		setBuriedProducts([])
		setHiddenProducts([])
		setOriginalProducts([])
		setPinnedItems({})
		setHiddenProductIndex({})
		setPinnedProductIndex({})
		setSelectedPromoTiles({})
		setChannelId(channelIdLocal)
	}

	return (
		<React.Fragment>
			<MenuHeader title={"General"} />
			<div className='sideBarMenuGridContainer' ref={divRef} style={{height: height, position: "relative"}}>
				<div className='menuContentWrapper'>
					<div className="d-flex flex-column p-4">
						{(pageLoader || channelLoader) ?
							<DetailSkeleton />
						:
							<Form onSubmit={(e) => e.preventDefault()}>
								{Object.keys(channels).length > 1 &&
									<FormGroup style={{marginBottom: "20px"}}>
										<div>
											{type === "new" ?
												<>
													<label style={{ display: 'block', marginBottom: '4px', fontWeight: 'bold' }}>
														Channel (Required)
													</label>
													<Select
														isSearchable={true}
														placeholder="Select Channel"
														maxMenuHeight={300}
														isRequired={true}
														menuPosition="fixed"
														menuPlacement="bottom"
														value={channelId ? { 
														value: channelId, 
														label: channels[channelId]?.name 
														} : null}
														options={Object.keys(channels).map(channelId => ({
														value: channelId, 
														label: channels[channelId].name
														}))}
														onChange={(selectedOption) => updateChannelId(selectedOption?.value)}
														onMenuOpen={() => setChannelSelect(true)}
														onMenuClose={() => setChannelSelect(false)}
													/>
												</>
											: ( type === "edit" && editSearchPhraseMerchandising )&&
												<>
													<h4 className='mb-2 font-bold'>Channel</h4>
													<h6>{channels[editSearchPhraseMerchandising.channelId].name}</h6>
												</>
											}
										</div>
									</FormGroup>
								}
								<FormGroup style={{marginBottom:"20px"}}>
									<div>
										{type === "new" ?
											<Input
												label={"Search Phrase (required)"}
												value={searchPhrase}
												placeholder='Enter query pattern'
												required
												onChange={(e) => setSearchPhrase(e.target.value)}
											/>
										: ( type === "edit" && editSearchPhraseMerchandising ) &&
											<>
												<h4 className='mb-2 font-bold'>Search Pattern</h4>
												<h6>{editSearchPhraseMerchandising.searchPhrase}</h6>
											</>
											
										}
									</div>
								</FormGroup>
								<div>
									{type === "new" ?
										<>
											<FormGroup check>
												<Input
													type="radio"
													checked={exact}
													onChange={() => setExact(true)}
													value={"true"}
												/>
												<label>Exact Match</label>
											</FormGroup>
											<FormGroup check>
												<Input
													type="radio"
													checked={!exact}
													onChange={() => setExact(false)}
													value={"false"}
												/>
												<label>Broad Match</label>
											</FormGroup>
										</>
									: ( type === "edit" && editSearchPhraseMerchandising ) &&
										<FormGroup>
											<h6>{editSearchPhraseMerchandising.exact ? "Exact Match" : "Broad Match"}</h6>
										</FormGroup>
									}
								</div>
								<FormGroup style={{marginBottom: "20px"}}>
									<Input
										type="textarea"
										label="Description"
										onChange={(e) => setDescription(e.target.value)}
										placeholder="Description"
										resize={"true"}
										rows={3}
										value={description}
									/>
								</FormGroup>
								{merchandisingError &&
									<p>{merchandisingError}</p>
								}
							</Form>
						}
					</div>
				</div>
			</div>
		</React.Fragment>
	)
}
export default GeneralSearch;